import React, { useEffect, useRef } from "react";
import SizeButton from "../shared/sizeButton";
import { __t } from "../../utils/translate";

type AttributeSelectorProps = {
    className?: string;
    attribute: any;
    setAttribute: (attribute: Record<string, unknown>) => void;
    selectedAttribute: string;
    layoutType?: boolean;
    isCoupon: boolean;
    isBundle?: boolean;
    itemId: number;
};

const AttributeSelector: React.FC<AttributeSelectorProps> = ({
    className = "",
    attribute,
    setAttribute,
    selectedAttribute,
    layoutType = true,
    isCoupon,
    isBundle,
    itemId
}) => {
    const label = attribute.name;
    const activeButtonRef = useRef(null);

    return (
        <>
            <div className="block w-full">
                <div data-cy="product_attribute" className={`${className} relative py-1`}>
                    <div className="flex flex-row justify-between items-center md:p-0 mb-[10px]">
                        <div className={`${isCoupon ? '' : ''} text-dark text-[15px] leading-6`}>
                            {label}
                        </div>
                    </div>

                    <div
                        className={`flex justify-start ${isCoupon ? 'bottom-full' : ''}
                            md:w-full flex-wrap flex-row gap-[6px] static pb-2`}
                    >
                        {!!(attribute.options) && attribute.options
                            .map((option: { slug: React.Key | null | undefined; name: string; }) => {
                                return (
                                    <SizeButton
                                        ref={option.slug === selectedAttribute ? activeButtonRef : null}
                                        isCoupon={isCoupon}
                                        key={option.slug}
                                        text={option.name}
                                        isSelected={selectedAttribute === option.slug}
                                        onClick={() => {
                                            setAttribute({ [isBundle ? `bundle_attribute_` + attribute.slug + '_' + itemId : attribute.slug]: option.slug });
                                        }}
                                    />
                                );
                            })}
                    </div>

                </div>
            </div>
        </>
    );
};

export default AttributeSelector;